import React, { useContext } from "react";
import FlexBox from "../../../FlexBox/FlexBox";
import { ILandingEngagementItem } from "../LandingEngagements";
import Typography from "../../../../Foundation/Typography/Typography";
import { ImageResponsive } from "../../../Image";
import { ImageFit } from "../../../Image/interface/ImageData";
import { _EngagementItemRoot } from "./EngagementItem.styled";
import clsx from "clsx";
import LinkContext from "../../../../Core/Link/Context/LinkContext";

export interface IEngagementItemProps {
  engagement: ILandingEngagementItem;
  className?: string;
  style?: React.CSSProperties;
}

const EngagementItem = (props: IEngagementItemProps) => {
  const { engagement, className, style } = props;
  const { imageId, title, subtitle, url } = engagement;
  const { FlexBoxLink } = useContext(LinkContext);

  return (
    <_EngagementItemRoot
      as={FlexBoxLink}
      to={url + ""}
      direction="column"
      justify="center"
      align="center"
      gap={24}
      className={className}
      style={style}
    >
      <div className={clsx("innovation-product")}>
        <ImageResponsive
          alt={engagement.title}
          desktop={{
            image: {
              id: imageId,
              fit: ImageFit.CONTAIN,
              quality: 80,
              aspectRatio: 1,
              width: 162,
            },
            wrapperStyle: {
              maxWidth: 162,
              borderRadius: 0,
              overflow: "hidden",
              aspectRatio: 1,
            },
            imgStyle: {
              width: 162,
              aspectRatio: 1,
            },
          }}
          mobile={{
            image: {
              id: imageId,
              fit: ImageFit.CONTAIN,
              quality: 100,
              aspectRatio: 1,
              outputPixelDensities: [1, 2],
              width: 162,
            },
            wrapperStyle: {
              maxWidth: 162,
              width: 162,
              borderRadius: 4,
              aspectRatio: 1,
              overflow: "hidden",
            },
            imgStyle: {
              width: 162,
              aspectRatio: 1,
            },
          }}
        />
      </div>
      <FlexBox
        direction="column"
        align="center"
        gap={8}
        style={{ height: "100%" }}
      >
        <Typography variant="h7" align="center" style={{ fontWeight: "bold" }}>
          {title}
        </Typography>
        <Typography variant="subtitle2" align="center">
          {subtitle}
        </Typography>
      </FlexBox>
    </_EngagementItemRoot>
  );
};

export default EngagementItem;
